// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"ReserveNowFaq_modalWrapper__SvqGM","title":"ReserveNowFaq_title__dey40","description":"ReserveNowFaq_description__m7WHF"};